import React from 'react';
import {HapvidaAppIconProps} from './types';

export const HapvidaAppIcon = ({size}: HapvidaAppIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 64 64"
		fill="none"
		style={{minWidth: size || 34}}
		height={size}
		width={size}>
		<rect width="64" height="64" fill="#1539AA" />
		<path
			d="M12.9002 25.4177C11.0328 28.6488 13.2423 32.5547 18.8241 34.7015C21.7476 35.8251 26.6358 36.062 29.8245 35.2005C28.9787 32.0086 26.3345 27.8909 23.9006 25.9167C19.2557 22.1505 14.7676 22.1866 12.9002 25.4177Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9932 12.25C27.9462 12.25 25.4777 16.4431 26.4915 22.8488C27.0234 26.2039 29.4542 30.9227 31.9932 33.4476C34.5323 30.9211 36.963 26.2039 37.495 22.8488C38.5103 16.4446 36.0403 12.25 31.9932 12.25Z"
			fill="#FF222B"
		/>
		<path
			d="M51.1019 25.4287C49.2392 22.196 44.7496 22.1568 40.1015 25.9183C37.6661 27.8877 35.0172 32.0039 34.1698 35.1958C37.3569 36.0589 42.2451 35.8282 45.1702 34.7062C50.7536 32.5657 52.9662 28.6614 51.1019 25.4287Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9932 51.75C34.4836 51.75 36.0042 49.1686 35.3797 45.2266C35.0517 43.1614 33.5562 40.2567 31.9932 38.7031C30.4303 40.2583 28.9348 43.1614 28.6068 45.2266C27.9823 49.1686 29.5029 51.75 31.9932 51.75Z"
			fill="#FFCC23"
		/>
		<path
			d="M18.5213 44.0527C19.7657 46.2105 22.7614 46.2372 25.8638 43.7263C27.4895 42.4113 29.2581 39.6651 29.823 37.5324C27.6951 36.9565 24.4326 37.1103 22.4805 37.8589C18.7535 39.2869 17.2769 41.8934 18.5213 44.0527Z"
			fill="#FF8800"
		/>
		<path
			d="M45.4668 44.059C46.7128 41.9029 45.2392 39.2947 41.5139 37.862C39.5617 37.1103 36.2993 36.9534 34.1714 37.5293C34.7363 39.6604 36.5017 42.4082 38.1243 43.7263C41.2251 46.2403 44.2208 46.2168 45.4668 44.059Z"
			fill="#FF8800"
		/>
	</svg>
);
